import { Injectable, inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { RegisterUserForm } from '../interfaces';
import { MovilityType, TripType } from '../interfaces/register-user.response';
import { initialTransportMeans } from '../shared/components/transport-means-field/config/constants';
import { minArrayLengthValidator } from '../shared/form/validators';
import { RestService } from '../../../services/rest.service';

@Injectable({
  providedIn: 'root'
})
export class RegisterUserFormFactoryService {
  private readonly _fb = inject(FormBuilder);
  private readonly _restService = inject(RestService);

  createForm(): FormGroup<RegisterUserForm> {
    const form = this._fb.group<RegisterUserForm>({
      startDate: new FormControl<Date | null>(null, Validators.required),
      endDate: new FormControl<Date | null>(null, Validators.required),
      startTime: new FormControl<string | null>(null),
      endTime: new FormControl<string | null>(null),
      startLocationAddress: new FormControl<string>(null, Validators.required),
      startLocationLat: new FormControl<number>(null, Validators.required),
      startLocationLng: new FormControl<number>(null, Validators.required),
      endLocation: new FormControl<boolean>(false, Validators.required),
      movilityType: new FormControl<MovilityType | null>(null),
      tripType: new FormControl<TripType>(null, Validators.required),
      interestIdList: new FormControl<number[]>(null, [Validators.required, minArrayLengthValidator(3)]),
      transportMeans: new FormControl<string[]>([initialTransportMeans.value], Validators.required),
      maxDistanceWalking: new FormControl<number>(200, Validators.required),
      geolocation: new FormControl<boolean>(false),
      // ✅ Inicializar sin valor, lo estableceremos después
      subdomain: new FormControl<string>(null, Validators.required),
    });

    // ✅ Establecer el subdomain después de crear el formulario
    this._setSubdomain(form);

    return form;
  }

  private _setSubdomain(form: FormGroup<RegisterUserForm>): void {
    // ✅ Intentar obtener el subdomain
    const subdomain = this._restService.subDomain;
    
    console.log('RestService subdomain:', subdomain);
    
    if (subdomain) {
      form.get('subdomain')?.setValue(subdomain);
      console.log('Subdomain set to:', subdomain);
    } else {
      // ✅ Si no está disponible, usar un valor por defecto o esperar
      console.warn('Subdomain not available from RestService');
      
      // Opcional: establecer un valor por defecto
      form.get('subdomain')?.setValue('default-subdomain');
    }
  }
}